import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';

import injectReducer from 'utils/injectReducer';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import {
  makeSelectStep3,
  makeSelectStep3Errors,
  makeSelectBsbValidating,
  makeSelectBsbNotice,
} from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import { length, required } from '../../../utils/validation/validator';
import Textbox from '../components/Textbox/index';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation/';
import {
  handleFormDataChange,
  nextSlide,
  resetFormRegisterGstState,
  closeBSBNotice,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import P from '../../../components/P/index';
import { saveFormData } from '../actions';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { getBank, getBankSuccess } from '../../FastCover/actions';
import ModalNotice from './components/ModalNotice';
import InvalidBSBWarning from './components/InvalidBSBWarning';
import HelpText from '../../../components/HelpText';
import TextArea from '../components/TextArea';

export class Step3 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      showModal: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.saveButtonId = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
    this.invalidBSBWarning = null;

    this.lastCheckingBSB = props.form.bsbNumber;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getBankByBsb = (event) => {
    // this.validatorGroup.checkValidation();
    // const isInvalid = this.validatorGroup.checkError('bsbNumber');
    // if (isInvalid === false) {
    const value = event.target.value;
    if (!value) {
      const bankInfo = {
        isBsbValid: false,
        nameOfBank: '',
        branch: '',
        bsbCannotBeVerified: false,
      };
      this.props.getBankSuccess(bankInfo);
    } else if (this.lastCheckingBSB !== value) {
      this.lastCheckingBSB = event.target.value;
      this.props.onGetBankByBSB(this.lastCheckingBSB);
    }
    // }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.checkBSBValidation();
    this.props.onFormDataSave();
    this.nextButton.focus();
    this.checkFormError();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    // this.props.makeDirty(2);
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  checkBSBValidation = () => {
    const { isBsbValid, bsbCannotBeVerified } = this.props.form;
    if (!isBsbValid && !bsbCannotBeVerified) {
      this.showModal();
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    // const errors = this.validatorGroup.getErrors();
    this.checkFormError();

    this.props.onFormDataSave();
    this.props.next();
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleResetPartialFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  closeModal = () => {
    this.setState({ showModal: false });
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  renderRegisterdGSTPurpuseInfo = () => {
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    const { registerForGSTPurpose, abn, percentageOfGST, claimITC } = isSummary
      ? this.summaryFormValue()
      : this.props.form;
    return (
      registerForGSTPurpose === 'true' && (
        <div>
          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="abn"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.whatIsYourABN}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="abn"
                  type="number"
                  placeholder=""
                  onChange={this.handleChange('form.abn')}
                  value={abn}
                />
                <ErrorMessage for="required">
                  &apos;Australian Business Number&apos; is required
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className={'row'}>
            <div className={'col-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.claimITC} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={claimITC === 'true'}
                    onChange={this.handleChange('form.claimITC')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={claimITC === 'false'}
                    onChange={this.handleChange('form.claimITC')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>

          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="percentageOfGST"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.whatPercentageOfGST}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="percentageOfGST"
                  type="number"
                  onChange={this.handleChange('form.percentageOfGST')}
                  value={percentageOfGST}
                />
                <ErrorMessage for="required">
                  &apos;Percentage of GST&apos; is required
                </ErrorMessage>
              </Validate>
            </div>
          </div>
        </div>
      )
    );
  };

  renderOtherInsuranceDetail() {
    const { isSummary, submitted } = this.props;
    const { otherInsurance, provideDetails } = isSummary
      ? this.summaryFormValue()
      : this.props.form;
    const isReadOnly = submitted || isSummary;
    return (
      otherInsurance === 'true' && (
        <div className={'form-group'}>
          {/* <PageSectionHeader> */}
          {/* <FormattedMessage {...messages.ifYesPleaseProvideDetails} /> */}
          {/* </PageSectionHeader> */}
          <Validate
            name="provideDetails"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={provideDetails}
            fieldName={messages.ifYesPleaseProvideDetails}
          >
            <TextArea
              disabled={isReadOnly}
              name="provideDetails"
              type="text"
              onChange={this.handleChange('form.provideDetails')}
              value={provideDetails}
              isSummary={isSummary}
            />
            <ErrorMessage for="required">
              <FormattedMessage
                {...messages.isRequired}
                values={messages.ifYesPleaseProvideDetails}
              />
            </ErrorMessage>
          </Validate>
        </div>
      )
    );
  }

  render() {
    const {
      isSummary,
      submitted,
      loading,
      bsbValidating,
      showBSBNotice,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      nameOfBank,
      branch,
      bsbNumber,
      accountNumber,
      accountHolder,
      registerForGSTPurpose,
      otherInsurance,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { showModal } = this.state;
    const { bsbCannotBeVerified, isBsbValid } = this.props.form;
    return (
      <div className="app-content">
        <div className={'row'}>
          <div className={'col'}>
            <P>
              <FormattedMessage {...messages.depositMessage} />
            </P>
            <P style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10 }}>
              <FormattedMessage {...messages.pleaseNote} />
            </P>
            <ul style={{ margin: 0 }}>
              <li>
                <FormattedMessage
                  {...messages.weCannotDepositIntoACreditCardAccount}
                />
              </li>
            </ul>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-8 form-group mb02'}>
            <Validate
              name="accountHolder"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountHolder}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountHolder"
                type="text"
                onChange={this.handleChange('form.accountHolder')}
                value={accountHolder}
              />
              <ErrorMessage for="required">
                &apos;Account holder&apos; is required
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="bsbNumber"
              group={this.validatorGroup}
              validators={[required, length(6)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bsbNumber}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="bsbNumber"
                type="number"
                onBlurCapture={this.getBankByBsb}
                onChange={this.handleChange('form.bsbNumber')}
                value={bsbNumber}
              />
              <ErrorMessage for="required">
                &apos;BSB Number&apos; is required
              </ErrorMessage>
              <ErrorMessage for="m_length">
                <FormattedMessage {...messages.bsbNumberLengthValidation} />
              </ErrorMessage>
            </Validate>
          </div>
          <div
            className={'col-md-8 form-group mb02'}
            style={{
              justifyContent: 'flex-end',
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <OptionsContainer>
              <input
                disabled={isReadOnly || isBsbValid || !bsbNumber}
                type="checkbox"
                name="bsbCannotBeVerified"
                checked={bsbCannotBeVerified}
                onChange={this.handleChange('form.bsbCannotBeVerified')}
              />
              <span>
                <FormattedMessage {...messages.bsbCannotBeVerified} />
              </span>
            </OptionsContainer>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="nameOfBank"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={nameOfBank}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.nameOfBank}
            >
              <Textbox
                disabled={
                  isReadOnly ||
                  isBsbValid ||
                  (!isBsbValid && !bsbCannotBeVerified)
                }
                name="nameOfBank"
                type="text"
                onChange={this.handleChange('form.nameOfBank')}
                value={nameOfBank}
              />
              <ErrorMessage for="required">
                &apos;Name of Bank&apos; is required
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.branch} />
            </PageSectionHeader>
            <Textbox
              disabled={
                isReadOnly ||
                isBsbValid ||
                (!isBsbValid && !bsbCannotBeVerified)
              }
              name="branch"
              type="text"
              onChange={this.handleChange('form.branch')}
              value={branch}
            />
          </div>
        </div>
        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="accountNumber"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountNumber}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountNumber"
                type="number"
                onChange={this.handleChange('form.accountNumber')}
                value={accountNumber}
              />
              <ErrorMessage for="required">
                &apos;Account number&apos; is required
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className={'row mt-3'}>
          <div className={'col-12 form-group mb02'}>
            <span style={{ fontWeight: 'bold', fontSize: '0.86em' }}>
              <FormattedMessage {...messages.GSTInfo} />
            </span>
          </div>
        </div>

        <div className={'row mb-2'}>
          <div className={'col-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.areYouRegisteredForGTSPurposes} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={registerForGSTPurpose === 'true'}
                  onChange={this.handleChange('form.registerForGSTPurpose')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={registerForGSTPurpose === 'false'}
                  onChange={this.handleResetPartialFormState(
                    'form.registerForGSTPurpose',
                    this.props.onResetRegisterGstState
                  )}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>

        {this.renderRegisterdGSTPurpuseInfo()}
        <div className={'form-group'}>
          <PageSectionHeader>
            <FormattedMessage {...messages.doYouHaveAnotherOtherInsurance} />
          </PageSectionHeader>
          <FlexBox>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                checked={otherInsurance === 'true'}
                onChange={this.handleChange('form.otherInsurance')}
                value="true"
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                checked={otherInsurance === 'false'}
                onChange={(event) => {
                  this.handleChange('form.otherInsurance')(event);
                  this.props.onFormDataChange('form.provideDetails', '');
                }}
                value="false"
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
          <HelpText>
            <FormattedMessage {...messages.exampleHomeContentsInsurance} />
          </HelpText>
        </div>
        {this.renderOtherInsuranceDetail()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={() => {
                      this.props.prev();

                      // make sure next button is not focus, avoid break wizard slider
                      if (document.activeElement) {
                        document.activeElement.blur();
                      }
                    }}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
        <ModalNotice
          isOpen={showBSBNotice}
          onClose={this.props.closeBSBNotice}
        />
        <InvalidBSBWarning isOpen={showModal} onClose={this.closeModal} />
      </div>
    );
  }
}

Step3.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  onResetRegisterGstState: PropTypes.func,
  currentStep: PropTypes.number,
  step: PropTypes.number,
  isReadOnly: PropTypes.number,
  loading: PropTypes.bool,
  errors: PropTypes.array,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  submitted: PropTypes.bool,
  isSummary: PropTypes.bool,
  bsbValidating: PropTypes.bool,
  onGetBankByBSB: PropTypes.func,
  showBSBNotice: PropTypes.bool,
  closeBSBNotice: PropTypes.func,
  getBankSuccess: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  currentStep: makeSelectCurrentStep(),
  form: makeSelectStep3(),
  errors: makeSelectStep3Errors(),
  loading: makeSelectProgressBarStatus(),
  bsbValidating: makeSelectBsbValidating(),
  showBSBNotice: makeSelectBsbNotice(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetRegisterGstState: () => dispatch(resetFormRegisterGstState()),
  onGetBankByBSB: (bsb) => dispatch(getBank(bsb)),
  closeBSBNotice: () => dispatch(closeBSBNotice()),
  getBankSuccess: (bankInfo) => dispatch(getBankSuccess(bankInfo)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'step3', reducer });

export default compose(
  withReducer,
  withConnect
)(Step3);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step3/index.js